import React from 'react';
import scheduleSnap from '../utils/scheduleSnap';

const TIMES = scheduleSnap.quarterHours();

function engineerName(person) {
  return [person.first_name, person.last_name].filter(Boolean).join(' ') || `Engineer ${person.id}`;
}

function JobAssignmentFields({ personId, date, time, engineers, onPerson, onDate, onTime }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="job-assign-engineer">
          Engineer
        </label>
        <select
          id="job-assign-engineer"
          data-testid="job-assign-engineer"
          value={personId}
          onChange={(event) => onPerson(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white"
        >
          <option value="">Unallocated</option>
          {engineers.map((person) => (
            <option key={person.id} value={String(person.id)}>
              {engineerName(person)}
            </option>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="job-assign-date">
          Date
        </label>
        <input
          id="job-assign-date"
          data-testid="job-assign-date"
          type="date"
          value={date}
          onChange={(event) => onDate(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white"
        />
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2" htmlFor="job-assign-time">
          Start time
        </label>
        <select
          id="job-assign-time"
          data-testid="job-assign-time"
          value={time}
          onChange={(event) => onTime(event.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-white"
        >
          <option value="">Default 08:00</option>
          {TIMES.map((slot) => (
            <option key={slot} value={slot}>{slot}</option>
          ))}
        </select>
      </div>
      <p className="sm:col-span-3 text-xs text-gray-500">
        Choose both an engineer and a date, or leave both blank. The start time snaps to 15 minutes.
      </p>
    </div>
  );
}

export default JobAssignmentFields;
